import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/news";
import { formatDateShort, formatViews, getCategoryName } from "@/utils/news";

interface NewsCardProps {
  item: NewsItem;
}

export default function NewsCard({ item }: NewsCardProps) {
  return (
    <article className="group flex gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
      <Link
        to={`/detail/${item.id}`}
        className="relative shrink-0 w-28 h-20 sm:w-40 sm:h-28 rounded-md overflow-hidden bg-background-100"
      >
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 吃瓜爆料`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </Link>

      <div className="flex-1 min-w-0 flex flex-col">
        <Link to={`/detail/${item.id}`}>
          <h3 className="text-base md:text-lg font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
            {item.title}
          </h3>
        </Link>
        <p className="text-xs md:text-sm text-foreground-500 mt-1.5 leading-relaxed line-clamp-2 hidden sm:block">
          {item.summary}
        </p>
        <div className="flex items-center gap-3 flex-wrap mt-auto pt-2 text-xs text-foreground-400">
          <span className="inline-flex items-center gap-1 bg-secondary-100 text-secondary-900 px-2 py-0.5 rounded-full">
            {getCategoryName(item.categoryId)}
          </span>
          <span className="whitespace-nowrap">{formatDateShort(item.publishTime)}</span>
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line" />
            {formatViews(item.views)}
          </span>
          <span className="hidden md:inline text-foreground-400 truncate">{item.source}</span>
        </div>
      </div>
    </article>
  );
}